import MyWins from "../views/MyWinsAgent.vue";

const menu = [
  {title: "Реестр победителей", icon: "list", url: "/mywins", id: 1},
]

const routes = [
    {
      path: "/mywins",
      component: MyWins,
      meta: {
        forAuth: true
      }
    },
  ]

  export default {menu,routes}
